import axios from "axios";
import react from "../assets/react.svg"

async function getDataStats() {
    const apiURL = "https://api-ekata.ekata.id/api/stats";

  return await axios
    .get(apiURL).then((response) => {
        console.log("Stats : ",response.data.data);
        return response.data.data;
    }).catch((error) => {
        console.log(error);
        return [
            {
                stat_id: 3,
                stat_title: 'Not Found',
                stat_count: '99999+',
                icon_url: react,
            },
        ];
    });
}

export { getDataStats };